// 常量
const CONSTANT = {
  SUBMIT_MEAL_PERIOD: [
    {
      label: '早餐',
      value: 'breakfast',
      money: 'breakfastMoney'
    },
    {
      label: '午餐',
      value: 'lunch',
      money: 'lunchMoney'
    },
    {
      label: '晚餐',
      value: 'dinner',
      money: 'dinnerMoney'
    },
    {
      label: '夜宵',
      value: 'night',
      money: 'nightMoney'
    }
  ],
  // 消费明细-消费类型
  CONSUME_TYPE: ['食堂', '餐券', '伙食费', '淋浴']
};

export default CONSTANT;
